<!-- <app-header-one  ></app-header-one> -->
<!-- <ngx-loading-bar></ngx-loading-bar> -->
<app-ripple-loader *ngIf="isLoading"></app-ripple-loader>
<app-spinner-loader></app-spinner-loader>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<app-layout-box></app-layout-box>
<!-- <app-footer-one ></app-footer-one> -->
